
import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import {
    FLUSH,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
    REHYDRATE,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';

// reducers
import authReducer from './authSlice';

// combine reducers
const rootReducer = combineReducers({
    auth: authReducer,
});

// persist config 
const persistConfig = {
    key: 'root', // localstorage key
    storage,
};

// persist reducer 
const persistedReducer = persistReducer(persistConfig, rootReducer);

// configure the store
const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
    devTools: process.env.NODE_ENV !== 'production',
});

// create persistor
export const persistor = persistStore(store);

export default store;
